import React from "react";

import Skeleton from "@ingka/skeleton";

import SelectMarkets from "../../SelectMarkets/SelectMarkets";

interface MaintainerMarketSelectorLayoutProps {
	marketsDataLoading: boolean;
	marketsData?: { key: string; name: string }[];
	selectedMarkets: string[];
	requestingRole: boolean;
	setSelectedMarkets: (val: string[]) => void;
}

const Layout: React.FC<MaintainerMarketSelectorLayoutProps> = ({
	marketsDataLoading,
	selectedMarkets,
	marketsData,
	setSelectedMarkets,
	requestingRole,
}) => {
	if (marketsDataLoading) {
		return <Skeleton height="8rem" />;
	}

	return (
		<div>
			<p>Select markets for which you want to request Maintainer role</p>
			<SelectMarkets
				id="new-app-access"
				label="Select Markets"
				marketsData={marketsData}
				selected={selectedMarkets}
				onChange={setSelectedMarkets}
				disabled={requestingRole}
			/>
		</div>
	);
};

export default Layout;
